import moment from 'moment';
import React from 'react';

import { SMALL_TABLET_MAX_WIDTH } from 'constants/breakpoints';

import ShareButtonsWrapper from '../share-video/share-buttons';

import MediaQuery from 'components/media-query';
import UserAvatar from 'components/user-avatar';

import './styles.less';

const OwnerInfo = ({
  currentUserIsOwner,
  customLogoUrl,
  date,
  name,
  user,
  userAvatarSrc,
  video = {},
}) => (
  <div className="owner-info-and-move">
    <div className="owner-info">
      <UserAvatar avatarSrc={userAvatarSrc} name={name} avatarSize={6} />
      <div className="by-date">
        <div className="by">
          <span className="name">{name}</span>
        </div>
        <div className="date">{moment(date).format('LL')}</div>
      </div>
    </div>
    {user && ( // we check this to only show on the new share page
      <MediaQuery query={`(max-width: ${SMALL_TABLET_MAX_WIDTH}px)`}>
        <ShareButtonsWrapper
          className="ml:auto relative"
          currentUserIsOwner={currentUserIsOwner}
          user={user}
          video={video}
        />
      </MediaQuery>
    )}
    {customLogoUrl && (
      <img src={customLogoUrl} className="custom-brand-logo ml:small" />
    )}
  </div>
);

export default OwnerInfo;
